import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';

interface DataNode {
  name: string;
  value: string;
  children?: DataNode[];
}

@Component({
  selector: 'info-tree',
  templateUrl: './info-tree.component.html',
  styleUrls: ['./info-tree.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class InfoTreeComponent implements OnInit {

  tc = new NestedTreeControl<DataNode>(node => node.children);
  data = new MatTreeNestedDataSource<DataNode>();

  @Input()
  set json(jsonData) {
    this.data.data = this.generateJsonArray(jsonData);
  }

  @Input()
  keyValueMode = true;

  generateJsonArray(jsonValue): any {
    const arr: Array<DataNode> = [];

    for (const property in jsonValue) {
      if (!jsonValue.hasOwnProperty(property)) {
        continue;
      }

      if (!!jsonValue[property] && typeof jsonValue[property] === 'object') {
        arr.push({
          name: `${property}`,
          value: '',
          children: this.generateJsonArray(jsonValue[property])
        });
      } else {
        arr.push({
          name: `${property}: `,
          value: `${ !!jsonValue[property] ? jsonValue[property] : ''}`,
        });
      }
    }

    return arr;
  }

  hasChild(_: number, node): any {
    return node.children != null && node.children;
  }

  ngOnInit(): void {
  }

}
